import { Inject, Injectable } from "@angular/core";
import { LocaleServiceConfig, LocaleServiceConfigToken } from "./locale.service.config.model";
import { LocaleService } from "./locale.service";
import { CORE_STATE_NAME, CoreActionFactory, CoreActionFactoryToken } from "../../redux/redux.module";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";


/**
 * The default implemetation of the locale service.
 */
@Injectable()
export class LocaleServiceImpl implements LocaleService {
    _currentLocale: string;
    _config: LocaleServiceConfig;
    _localeState: Observable<any>;
    _ngRedux: Store;
    _coreActionFactory: CoreActionFactory;
    _availableLocales: string[];

    lang: string;

    constructor (
        @Inject(LocaleServiceConfigToken) config: LocaleServiceConfig,
        @Inject(CoreActionFactoryToken) coreActions: CoreActionFactory,
        ngRedux: Store<any>
    ) {
        this._config = config;
        this._ngRedux = ngRedux;
        this._coreActionFactory = coreActions;
        this._localeState = ngRedux.select(CORE_STATE_NAME, "locale");
        this._currentLocale =
            this._config.defaultLocale ||
            this.lang ||
            "hu";
        if (this._config.availableLocales.length < 1) {
            this._availableLocales = [this._currentLocale];
        } else {
            this._availableLocales = this._config.availableLocales;
        }

        this._localeState.subscribe(this.onLocaleStateChange.bind(this));
    }

    /**
     * Set the active locale. All text elements will be resolved to that language after the set.
     * @param locale The two character long locale code.
     */
    public setLocale (locale: string) {
        if (this.getLocale() === locale) {
            return;
        }

        if (this._availableLocales.indexOf(locale) === -1) {
            throw new Error("This locale (" + locale + ") is not amongst the available locales!");
        }

        this._coreActionFactory.setLocale(locale);
        this.storePreferredLocale(locale);
    }

    /**
     * Return the actively used locale code.
     * @returns {string} The two character long code of the active locale.
     */
    public getLocale (): string {
        return this._currentLocale || localStorage.getItem("locale");
    }

    /**
     * Returns the list of allowed locales.
     */
    public getAvailableLocales (): string[] {
        return this._availableLocales;
    }

    protected onLocaleStateChange(newLocale: string): void {
        this._currentLocale = newLocale ? newLocale : this._currentLocale;
    }

    protected storePreferredLocale(locale: string): void {
        if (localStorage) {
            localStorage.setItem("locale", locale);
        }
    }
}
